import { useState, useEffect } from 'react'
import { useQueryClient } from 'react-query'

import { useGetVoiceList, useLikeVoice } from 'src/pages/menu/hooks/useGetVoiceList'
import { useGetRecommendsData } from 'src/services/hooks/useFetchRecommends'
import useLoading from 'src/components/layouts/hooks/useLoading'

import Carousel from 'src/components/voicealbum/Carousel'
import { Wrapper } from 'src/components/common/Wrapper'
import Loading from 'src/components/layouts/Loading'
import { MainLayout } from 'src/components/layouts/MainLayout'
import MenuWrapper from 'src/components/menu/MenuWrapper'
import SubmenuHeader from 'src/components/menu/SubmenuHeader'
import { VoiceCard } from 'src/components/voicealbum/VoiceCard'
import { VoiceAlbumSelect } from 'src/components/voicealbum/VoiceAlbumSelect'
import { VoiceAlbumPagination } from 'src/components/common/VoiceAlbumPagination'

import { characterVoiceList } from 'src/constants/characters'
import { sortDirectionOptions } from 'src/constants/statusDropdown'

export const VoiceAlbums = () => {
  const { data: recommendMen, isLoading: isLoadingFetchRecommenMen } = useGetRecommendsData()
  const queryClient = useQueryClient()
  const [activeIndex, setActiveIndex] = useState(0)
  const [currentPage, setCurrPage] = useState(1)
  const [favoriteCount, setFavoriteCount] = useState(0)

  const [selectedOption, setSelectedOption] = useState(sortDirectionOptions[0])

  useEffect(() => {
    if (recommendMen && recommendMen.length > 0) {
      const recommendedItem = recommendMen.find(
        (item) => item.recommend && item.id !== 6 && item.id !== 7 && item.id < 12
      )
      if (recommendedItem) {
        setActiveIndex(recommendedItem.id - 1)
      } else {
        setActiveIndex(1)
      }
    }
  }, [recommendMen])

  const { mutate, isLoading: isUpdating } = useLikeVoice(
    activeIndex + 1,
    currentPage,
    selectedOption.direction
  )

  const { data, isLoading, refetch } = useGetVoiceList(
    activeIndex + 1,
    currentPage,
    selectedOption.direction
  )

  const { showLoading, progress } = useLoading([
    isLoading || isUpdating || isLoadingFetchRecommenMen
  ])

  const handleFavor = (item) => {
    const newFavoriteStatus = !item.isFavor
    if (newFavoriteStatus && favoriteCount >= 10) {
      return
    }

    mutate({ ID: item.id, favorite: newFavoriteStatus })

    setFavoriteCount((prevCount) => (newFavoriteStatus ? prevCount + 1 : prevCount - 1))
  }

  const handlePlay = (selectedItem) => {
    queryClient.setQueryData(
      ['voiceList', activeIndex + 1, currentPage, selectedOption.direction],
      (oldData) => {
        if (!oldData) return oldData
        return {
          ...oldData,
          items: oldData.items.map((item) => {
            if (item.id === selectedItem.id) {
              return { ...item, isPlay: !item.isPlay }
            }
            return { ...item, isPlay: false }
          })
        }
      }
    )
  }

  useEffect(() => {
    setCurrPage(1)
  }, [activeIndex])

  useEffect(() => {
    refetch()
  }, [currentPage, selectedOption])

  useEffect(() => {
    if (data && data.items && currentPage === 1) {
      const count = data.items.filter((item) => item.isFavor).length

      setFavoriteCount(count)
    }
  }, [data, currentPage])

  if (showLoading || !data) {
    return (
      <Wrapper>
        <Loading progress={progress} />
      </Wrapper>
    )
  } else {
    return (
      <>
        <MainLayout className="bg-menu-bg" active="menu" classNameHeader="">
          <MenuWrapper className="" overflow={true}>
            <SubmenuHeader title={'ボイスアルバム'} />
            <div className="overflow-y-auto h-[calc(100dvh-210px)] hidden-scroll">
              <div className="mt-2">
                <Carousel
                  characters={characterVoiceList}
                  activeIndex={activeIndex}
                  setActiveIndex={setActiveIndex}
                />
              </div>

              <div className="flex w-full h-[46px]">
                <div className="ml-auto mt-4 min-w-[140px] mr-7">
                  {data.items.length > 0 && (
                    <VoiceAlbumSelect
                      options={sortDirectionOptions}
                      currentValue={selectedOption}
                      setCurrentValue={setSelectedOption}
                    />
                  )}
                </div>
              </div>

              <div className="h-[calc(100dvh-24rem)] overflow-y-scroll hidden-scroll my-4 ">
                <div className="grid grid-cols-2 gap-x-3 gap-y-4 mx-auto w-[330px] ">
                  {data.items.map((voice) => (
                    <VoiceCard
                      quantity={voice.amount}
                      rarity={voice.rarity}
                      key={voice.id}
                      voiceLink={voice.voiceLink}
                      imgSrc={voice.imgSrc}
                      isFavor={voice.isFavor}
                      handleFavor={() => handleFavor(voice)}
                      handlePlay={() => handlePlay(voice)}
                      isPlay={voice.isPlay}
                    />
                  ))}
                </div>
              </div>

              {data.items.length > 0 && (
                <VoiceAlbumPagination
                  theme="pink"
                  totalPage={data.total_pages}
                  currPage={currentPage}
                  setCurrPage={setCurrPage}
                />
              )}
            </div>
          </MenuWrapper>
        </MainLayout>
      </>
    )
  }
}
